import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { eventLogger } from '~/shared/services/eventLogger'
import { setAnswersAction } from '~/shared/store/common/actions'
import { sendUserAnswersAction } from '~/shared/store/user/actions'
import { IStepInfo, TAnswer } from '~/shared/types/commonTypes'
import { appHistory } from '~/shared/utils'

export const useNextStep = ({
  pageId,
  pageName,
  question,
  nextPagePath,
}: IStepInfo) => {
  const dispatch = useDispatch()

  return useCallback(
    (userAnswer: TAnswer) => {
      dispatch(
        setAnswersAction({
          pageId,
          answers: userAnswer,
        }),
      )

      dispatch(sendUserAnswersAction())

      eventLogger.logQuestion({
        question,
        answers: userAnswer,
        pageName,
      })

      appHistory.goTo(nextPagePath)
    },
    [dispatch, nextPagePath, pageId, pageName, question],
  )
}
